import { createContext, useContext } from "react";

export interface IAuditLogContext {
  searchValue: string;
  /** Narrows the history to fields whose name contains this text. */
  keySearchValue?: string;
  showSearchResultsOnly: boolean;
  expandedItems?: Set<number>;
  onToggleExpanded?: (id: number) => void;
  expandAllNested?: boolean;
  /** Bumped on every "expand all" so pressing it again still reopens details that were closed by hand. */
  expandAllVersion?: number;
}

const AuditLogContext = createContext<IAuditLogContext>({
  searchValue: "",
  keySearchValue: "",
  showSearchResultsOnly: false,
  expandedItems: undefined,
  onToggleExpanded: undefined,
  expandAllNested: false,
  expandAllVersion: 0,
});

AuditLogContext.displayName = "AuditLogContext";

export const useAuditLogContext = (): IAuditLogContext =>
  useContext(AuditLogContext);

export { AuditLogContext };
